export default "__VITE_ASSET__B51Rw6ub__"